import getExperienceLabel from './getExperienceLabel'

jest.mock('src/components/pages/[town-translit]/lpu/[lpu-translit]/_functions/tStatic', () => ({
  __esModule: true,
  default: (text: string) => text,
}))

describe('getExperienceLabel', () => {
  describe('Когда стаж меньше года', () => {
    test('Тогда возвращается «меньше года»', () => {
      expect(getExperienceLabel(0)).toBe('меньше года')
    })
  })

  describe('Когда стаж 1 год', () => {
    test('Тогда число и форма «год»', () => {
      expect(getExperienceLabel(1)).toBe('1 год')
    })
  })

  describe('Когда стаж 3 года', () => {
    test('Тогда число и форма «года»', () => {
      expect(getExperienceLabel(3)).toBe('3 года')
    })
  })

  describe('Когда стаж 5 лет', () => {
    test('Тогда число и форма «лет»', () => {
      expect(getExperienceLabel(5)).toBe('5 лет')
    })
  })
})
